import { MentorProfilePutBody } from './MentorPortalService';

const TOGGLES: {
    key: keyof Pick<
        MentorProfilePutBody,
        'notifyNewMessage' | 'notifyBooking' | 'notifySessionReminder' | 'notifyMonthlyDigest'
    >;
    label: string;
    sublabel: string;
    collector: string;
}[] = [
    {
        key: 'notifyNewMessage',
        label: 'New message',
        sublabel: 'When a mentee sends you a message',
        collector: 'Stored now. Delivery arrives with Messages.',
    },
    {
        key: 'notifyBooking',
        label: 'Session booking',
        sublabel: 'When a mentee books a session',
        collector: 'Stored now. Delivery arrives with booking.',
    },
    {
        key: 'notifySessionReminder',
        label: 'Session reminder (24h)',
        sublabel: '24 hours before a scheduled session',
        collector: 'Stored now. Delivery arrives with booking.',
    },
    {
        key: 'notifyMonthlyDigest',
        label: 'Monthly digest',
        sublabel: 'A monthly summary of your mentorship activity',
        collector: 'Stored now. Delivery arrives with the SendGrid era / P6-BATCH-010.',
    },
];

type Props = {
    draft: MentorProfilePutBody;
    onChange: (patch: Partial<MentorProfilePutBody>) => void;
};

const MentorProfileNotifications = ({ draft, onChange }: Props) => (
    <>
        <div className="card border-0 shadow-sm rounded-3 bg-white" aria-label="Notification preferences">
              <div className="card-header bg-white border-bottom border-light-subtle p-3">
                <h6 className="font-18 font-600 mb-0 text-dark">Notification Preferences</h6>
                <p className="font-14 text-mute mb-0">Preferences save now. Delivery is not active. These are stored settings, not a claim that email was sent.</p>

              </div>
              <div className="list-group list-group-flush">
                {TOGGLES.map((item) => (
                    <div key={item.key} className="list-group-item d-flex align-items-center justify-content-between py-3 px-4 border-light-subtle bg-transparent">
                        <div>
                            <div className="font-16 font-600 text-dark ">{item.label}</div>
                            <div className="text-secondary font-14">{item.sublabel}</div>
                            <div className="text-secondary font-14">{item.collector}</div>
                        </div>
                       
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id={`mprof-${item.key}`}
                                checked={draft[item.key] === true}
                                onChange={(event) => onChange({ [item.key]: event.target.checked })}
                            />
                            <label className="form-check-label visually-hidden" htmlFor={`mprof-${item.key}`}>
                                {item.label}
                            </label>
                        </div>
                    </div>
                ))}
                
              </div>
            </div>
    </>
);

export default MentorProfileNotifications;
